export class OfflineFeatureFlagEvaluator {
  constructor(hash = {}) {
    this.stubbedFlags = hash || {}
  }

  variation(flag, default_value = null) {
    return this.findVariations(flag) || default_value
  }

  findVariations(flag) {
    return this.stubbedFlags[flag] || null
  }
}
